module.exports = __webpack_public_path__ + "img/begin_dark_gray.fd1cd920.svg";